function init() {

	const htmlClass        = 'js-nav-open'
	const htmlEl           = document.documentElement;
	const navTrigger       = document.getElementById('nav-trigger')
	const mobileOpenClass  = 'js-mobile-nav-open'
	const overlayOpenClass = 'js-overlay-open'

	// Loop through menu bars
	for (const menubar of document.querySelectorAll('[role="menubar"]')) {

		// Get menu items links in menu bar
		for (const menuitem of menubar.querySelectorAll('[role="menuitem"][aria-haspopup="true"]')) {

			const parent  = menuitem.parentElement // get parent list item
			const submenu = parent.querySelector('[data-menu-container]') // get submenu element

			// If submenu element exists
			if (submenu !== null) {

				// When menu item clicked, toggle value of 'aria-expanded' attribute
				menuitem.addEventListener('click', (e) => {
					e.preventDefault()

					const id = menuitem.getAttribute('id')

					// Loop through all other menu items and set 'aria-expanded' to 'false' to hide any opened menus
					for (const mi of menubar.querySelectorAll('[role="menuitem"][aria-haspopup="true"]:not(#' + id + ')')) {
						mi.setAttribute('aria-expanded', 'false')
					}

					const currAttr = menuitem.getAttribute('aria-expanded')
					const newVal   = (currAttr === 'false' ? 'true' : 'false')
					menuitem.setAttribute('aria-expanded', newVal)

					if (newVal === 'true') {
						htmlEl.classList.add(htmlClass)
						htmlEl.classList.add(overlayOpenClass)
					} else {
						htmlEl.classList.remove(htmlClass)
						htmlEl.classList.remove(overlayOpenClass)
					}
				})

				// Watch menu item for when 'aria-expanded' attribute is changed
				const obs = new MutationObserver((mutationList) => {

					const clickedEl  = mutationList[0].target // get clicked menu item
					const isExpanded = (clickedEl.getAttribute('aria-expanded') === 'true' ? true : false) // determine if menu item should be expanded

					if (isExpanded) {

						// const displayType = (submenu.classList.contains('flex') ? 'flex' : 'block') // Determine if submenu uses flex of not
						submenu.style.display = 'block'

					} else {

						submenu.removeAttribute('style')
					}
				})

				obs.observe(menuitem, {attributeFilter: ['aria-expanded']}) // observe menu item for mutation
			}
		}

		for (const backBtn of menubar.querySelectorAll('[data-menu-back-btn]')) {

			backBtn.addEventListener('click', () => {

				const liParent = backBtn.closest('li')
				const menuitem = liParent.querySelector('[role="menuitem"]')

				menuitem.setAttribute('aria-expanded', 'false')
				htmlEl.classList.remove(htmlClass)
				htmlEl.classList.remove(overlayOpenClass)
			})
		}

		for (const btn of menubar.querySelectorAll('[data-submenu-btn]')) {

			btn.addEventListener('click', () => {

				const liParent         = btn.closest('li')
				const submenuContainer = liParent.querySelector('[data-submenu-container]')

				submenuContainer.style.display = 'block'
			})
		}

		for (const btn of menubar.querySelectorAll('[data-submenu-back-btn]')) {

			btn.addEventListener('click', () => {

				const liParent         = btn.closest('li')
				const submenuContainer = liParent.querySelector('[data-submenu-container]')

				submenuContainer.removeAttribute('style')
			})
		}
	}

	// When overlay clicked, close all open submenus
	const overlay = document.getElementById('overlay')
	overlay.addEventListener('click', () => {

		for (const menuitem of document.querySelectorAll('[role="menuitem"][aria-haspopup="true"]')) {
			menuitem.setAttribute('aria-expanded', 'false')
		}
		htmlEl.classList.remove(htmlClass)
		htmlEl.classList.remove(overlayOpenClass)
	})

	// Toggle html class when nav trigger clicked
	navTrigger.addEventListener('click', () => {
		htmlEl.classList.toggle(mobileOpenClass)
	})

	// Let the document know when the mouse is being used
	document.body.addEventListener('mousedown', function() {
		document.body.classList.add('using-mouse');
	});

	// Re-enable focus styling when Tab is pressed
	document.body.addEventListener('keydown', function(event) {
		if (event.keyCode === 9) {
			document.body.classList.remove('using-mouse');
		}
	});
}

export default init
